import * as React from "react";
import classnames from "classnames";
import { useDropdownContext } from "../../../../../context/ButtonDropdown/context/ButtonDropdownContext.js";
import { ButtonDropdownIcon } from "../../../../ButtonDropdownIcon/ButtonDropdown/components/ButtonDropdownIcon/ButtonDropdownIcon.js";
const ButtonDropdownSelect = ({ className, placeholder, id }) => {
  const {
    contentId,
    isOpen,
    value,
    isRequired,
    isInvalid = false,
    isDisabled,
    "aria-label": ariaLabel,
    floatingProps: {
      getReferenceProps,
      floatingContext: { refs }
    },
    toggle,
    cols
  } = useDropdownContext();
  const popupType = cols && cols > 1 ? "grid" : "listbox";
  const buttonClassNames = classnames("button-dropdown__select", className, {
    "button-dropdown__select--is-open": isOpen,
    "button-dropdown__select--disabled": isDisabled
  });
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      role: "combobox",
      "aria-controls": contentId,
      disabled: isDisabled,
      "aria-expanded": isOpen,
      "aria-autocomplete": "none",
      "aria-required": isRequired,
      "aria-invalid": isInvalid,
      "aria-haspopup": popupType,
      "aria-label": ariaLabel,
      className: buttonClassNames,
      value,
      ref: refs.setReference,
      id,
      ...getReferenceProps({
        onClick: toggle
      })
    },
    /* @__PURE__ */ React.createElement("span", { className: "button-dropdown__select-text" }, value ?? placeholder),
    /* @__PURE__ */ React.createElement(ButtonDropdownIcon, null)
  );
};
export {
  ButtonDropdownSelect
};
//# sourceMappingURL=ButtonDropdownSelect.js.map
